var render, staticRenderFns
import script from "./customMenu.vue?vue&type=script&lang=js&"
export * from "./customMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d0fda",
  null
  
)

export default component.exports